import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {StudyProgrammeDto} from '../modules/forms/modules/sp/models/osp';
import {HabilitationInaugurationDto} from '../modules/forms/modules/hip/models/hip';
import {Vtc} from '../modules/forms/modules/vtc/models/vtc';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) {
  }

  public getStudyProgrammes(): Promise<StudyProgrammeDto[]> {
    return this.http.get<StudyProgrammeDto[]>(`${environment.api_url}/study_programme`).toPromise();
  }

  public getHKIKs(): Promise<HabilitationInaugurationDto[]> {
    return this.http.get<HabilitationInaugurationDto[]>(`${environment.api_url}/habilitation_inauguration`).toPromise();
  }

  public getVTCsForUser(idEmployee: number): Promise<Vtc[]> {
    return this.http.get<any>(`${environment.api_url}/vtc/employee/${idEmployee}`).toPromise();
  }

  public deleteVTC(vtc: Vtc): Promise<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: vtc
    };

    return this.http.delete<any>(`${environment.api_url}/vtc`, options).toPromise();
  }
}
